import { render, staticRenderFns } from "./primaryEnrolmentReport.vue?vue&type=template&id=5e7411b7&scoped=true"
import script from "./primaryEnrolmentReport.vue?vue&type=script&lang=js"
export * from "./primaryEnrolmentReport.vue?vue&type=script&lang=js"
import style0 from "./primaryEnrolmentReport.vue?vue&type=style&index=0&id=5e7411b7&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7411b7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e7411b7')) {
      api.createRecord('5e7411b7', component.options)
    } else {
      api.reload('5e7411b7', component.options)
    }
    module.hot.accept("./primaryEnrolmentReport.vue?vue&type=template&id=5e7411b7&scoped=true", function () {
      api.rerender('5e7411b7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/printReport/primaryEnrolmentReport/primaryEnrolmentReport.vue"
export default component.exports